const Toggle = (props) => {

    const {
        isLabelWrapped,
        isHidden
    } = props;

    const toggleChange = (e) => {
        const checkbox = document.getElementById(props.id);
        if (e.target.className.includes('switch')) {
            e.target.checked = !checkbox.checked;
        }
        if (props.onChange) {
            if (props.emailAlert) {
                props.onChange(props.emailAlert);
            } else {
                props.onChange(e.target.checked);
            }
        }
    }

    const getToggleInput = () => {
        return (
            <>
                <div className={'toggle' + (isHidden ? ' hide' : '')} >
                    <input aria-label={props.ariaLabel} id={props.id} type='checkbox' checked={props.IsChecked} onClick={toggleChange} onKeyDown={(e) => { if (e.key === 'Enter') toggleChange() }} />
                    <div className={'toggle__switch' + (props.IsChecked ? ' toggle__switch_checked' : '')}></div>
                    <div className={'toggle__track' + (props.IsChecked ? ' toggle__track_checked' : '')}></div>
                </div>
            </>
        )
    }

    return (
        <div className={props.classNames ? props.classNames : ''}>
            {isLabelWrapped && props.label ?
                <label>
                    { getToggleInput() }
                    <span>{ props.label }</span>
                </label> :
                <>
                    {props.label && <label className={props.hideLabel ? 'visually-hidden': '' } htmlFor={props.id}> {props.label}</label>}
                    { getToggleInput() }
                </>
            }
        </div>
    );
};

export default Toggle;